import React, { useState, useEffect } from "react";
import { Badge } from "./ui/badge";
import { supabase } from "../integrations/supabase/client";
import { Bell } from "lucide-react";

interface NotificationBadgeProps {
  className?: string;
}

export function NotificationBadge({ className }: NotificationBadgeProps) {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    loadUnreadCount();
    
    // Set up real-time subscription for notifications
    const channel = supabase
      .channel('notifications')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notifications',
        },
        () => {
          loadUnreadCount();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const loadUnreadCount = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        return;
      }

      const { count, error } = await supabase
        .from("notifications")
        .select("*", { count: "exact", head: true })
        .eq("user_id", user.id)
        .eq("is_read", false);

      if (error) {
        console.error("Error loading unread count:", error);
        return;
      }

      setUnreadCount(count || 0);
    } catch (error) {
      console.error("Error loading unread count:", error);
    }
  };

  if (unreadCount === 0) {
    return (
      <div className={className}>
        <Bell className="h-5 w-5" />
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <Bell className="h-5 w-5" />
      <Badge 
        className="absolute -top-4 -right-4 h-5 w-5 rounded-full p-0 flex items-center justify-center text-xs font-bold bg-primary text-primary-foreground border-2 border-background shadow-sm"
      >
        {unreadCount > 99 ? "99+" : unreadCount}
      </Badge>
    </div>
  );
}
